import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../utils/api';

function AdminMalwareScanManager() {
const [enabled, setEnabled] = useState(true);
const [savedEnabled, setSavedEnabled] = useState(true);
const [updatedAt, setUpdatedAt] = useState(null);
const [updatedBy, setUpdatedBy] = useState('');
const [loading, setLoading] = useState(true);
const [saving, setSaving] = useState(false);
const [message, setMessage] = useState('');
const [error, setError] = useState('');
const token = localStorage.getItem('token');
const headers = { Authorization: `Bearer ${token}` };

const applySnapshot = (snapshot) => {
const nextEnabled = snapshot?.enabled !== false;
setEnabled(nextEnabled);
setSavedEnabled(nextEnabled);
setUpdatedAt(snapshot?.updatedAt || null);
setUpdatedBy(snapshot?.updatedBy || '');
};

useEffect(() => {
const load = async () => {
try {
const response = await axios.get(`${API_BASE}/admin/malware-scanning`, { headers });
applySnapshot(response.data);
} catch (requestError) {
setError(requestError.response?.data?.message || 'Failed to load malware scanning settings.');
} finally {
setLoading(false);
}
};
load();
// The token is fixed for the lifetime of this mounted admin view.
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

const save = async () => {
setSaving(true);
setMessage('');
setError('');
try {
const response = await axios.put(
`${API_BASE}/admin/malware-scanning`,
{ enabled },
{ headers }
);
applySnapshot(response.data);
setMessage(`Malware scanning ${response.data.enabled ? 'enabled' : 'disabled'}.`);
} catch (requestError) {
setError(requestError.response?.data?.message || 'Failed to update malware scanning settings.');
} finally {
setSaving(false);
}
};

if (loading) return <div style={styles.status}>Loading malware scanning settings…</div>;

return (
<div style={styles.container}>
  <div style={{...styles.statusCard, ...(enabled ? styles.enabledCard : styles.disabledCard)}}>
    <div>
      <h3 style={styles.statusTitle}>Malware scanning is {enabled ? 'enabled' : 'disabled'}</h3>
      <p style={styles.statusText}>
        Applies to Git pushes and uploaded plugin, workflow, and framework archives.
      </p>
    </div>
    <label style={styles.toggleLabel}>
      <input
        type="checkbox"
        checked={enabled}
        onChange={(event) => {
          setEnabled(event.target.checked);
          setMessage('');
          setError('');
        }}
        style={styles.checkbox}
      />
      Scan uploads for malware
    </label>
  </div>

  {!enabled && (
    <div role="alert" style={styles.warning}>
      <strong>Warning:</strong> uploads will not be checked by ClamAV. File-extension restrictions still apply to non-admin users.
    </div>
  )}

  {error && <div style={styles.error}>{error}</div>}
  {message && <div style={styles.success}>{message}</div>}

  <button
    onClick={save}
    disabled={saving || enabled === savedEnabled}
    style={{...styles.saveButton, ...((saving || enabled === savedEnabled) ? styles.disabledButton : {})}}
  >
    {saving ? 'Saving…' : 'Save malware setting'}
  </button>

  {(updatedAt || updatedBy) && (
    <p style={styles.audit}>
      Last changed {updatedAt ? new Date(updatedAt).toLocaleString() : ''}{updatedBy ? ` by ${updatedBy}` : ''}.
    </p>
  )}
</div>
);
}

const styles = {
container: { maxWidth: '850px' },
statusCard: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '24px', padding: '22px', borderRadius: '10px', border: '1px solid' },
enabledCard: { background: '#f0fdf4', borderColor: '#86efac' },
disabledCard: { background: '#fff7ed', borderColor: '#fdba74' },
statusTitle: { margin: '0 0 6px', color: '#0f172a' },
statusText: { margin: 0, color: '#475569', lineHeight: 1.5 },
toggleLabel: { display: 'flex', alignItems: 'center', gap: '10px', color: '#0f172a', fontWeight: 700, whiteSpace: 'nowrap', cursor: 'pointer' },
checkbox: { width: '20px', height: '20px', accentColor: '#16a34a' },
warning: { marginTop: '16px', padding: '14px 16px', borderRadius: '8px', background: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', lineHeight: 1.5 },
saveButton: { marginTop: '18px', padding: '11px 20px', border: 0, borderRadius: '6px', background: '#16a34a', color: 'white', cursor: 'pointer', fontWeight: 700 },
disabledButton: { background: '#94a3b8', cursor: 'not-allowed' },
error: { padding: '12px', marginTop: '14px', borderRadius: '6px', background: '#fee2e2', color: '#991b1b' },
success: { padding: '12px', marginTop: '14px', borderRadius: '6px', background: '#dcfce7', color: '#166534' },
audit: { color: '#64748b', fontSize: '13px' },
status: { padding: '30px', color: '#64748b' }
};

export default AdminMalwareScanManager;
